import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { ListingCard, PaginationLinks } from '../../components';
import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    currentUser,
    className = null,
    rootClassName = null,
    listings = [],
    pagination = null,
    search = null,
    setActiveListing,
    onAddToFavourites,
    addToFavouritesInProgress,
    addToFavouritesError,
    currentFavouritesListingId,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  // Panel width relative to the viewport
  const panelMediumWidth = 33.3333;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  return (
    <div className={classes}>
      <div className={css.listingCards}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            currentUser={currentUser}
            renderSizes={cardRenderSizes}
            setActiveListing={setActiveListing}
            onAddToFavourites={onAddToFavourites}
            addToFavouritesInProgress={addToFavouritesInProgress}
            addToFavouritesError={addToFavouritesError}
            currentFavouritesListingId={currentFavouritesListingId}
          />
        ))}
        {props.children}
      </div>
      {paginationLinks}
    </div>
  );
};

const { array, node, object, string } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
};

export default SearchResultsPanel;
